import type { LucideIcon } from 'lucide-react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface StatCardProps {
  label: string;
  value: string;
  change?: number | null;
  changeLabel?: string;
  icon: LucideIcon;
  iconColor?: string;
}

export default function StatCard({ label, value, change, changeLabel, icon: Icon, iconColor = 'text-water-600' }: StatCardProps) {
  const changeUp = change !== null && change !== undefined && change > 0;
  const changeDown = change !== null && change !== undefined && change < 0;

  return (
    <div className="bg-white dark:bg-[#1a1f1c] rounded-lg p-4 border border-stone-200 dark:border-stone-700">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-stone-500 dark:text-stone-400">{label}</p>
          <p className="text-2xl font-bold text-bark-900 dark:text-stone-100 mt-1">{value}</p>
          {change !== null && change !== undefined && (
            <div className={`flex items-center gap-1 mt-1 text-xs ${changeUp ? 'text-green-600' : changeDown ? 'text-red-500' : 'text-stone-400'}`}>
              {changeUp && <TrendingUp size={12} />}
              {changeDown && <TrendingDown size={12} />}
              <span>{changeUp ? '+' : ''}{change.toFixed(1)}%</span>
              {changeLabel && <span className="text-stone-400 ml-1">{changeLabel}</span>}
            </div>
          )}
        </div>
        <Icon className={iconColor} size={24} />
      </div>
    </div>
  );
}
